import React, { useMemo } from 'react';

const BetbookContext = React.createContext({
    isBetbook: false,
    betbookPostId: null,
    betbookPostType: null,
    betbookPostAuthor: null,
    betbookBetId: null,
    betbookBetSelectionCode: null
});

export default BetbookContext;

export function BetbookContextProvider({
    betbookPostId,
    betbookPostType,
    betbookPostAuthor,
    betbookBetId,
    betbookBetSelectionCode,
    children
}) {
    const contextValue = useMemo(() => {
        return {
            isBetbook: true,
            betbookPostId,
            betbookPostType,
            betbookPostAuthor,
            betbookBetId,
            betbookBetSelectionCode
        };
    }, [betbookPostId, betbookPostType, betbookPostAuthor, betbookBetId, betbookBetSelectionCode]);
    return <BetbookContext.Provider value={contextValue}>{children}</BetbookContext.Provider>;
}
